import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { AuthType } from 'types/authType';

export const reduceToNextAuthType = createReducer<null | AuthType, AppEvent>(
  (prev, event) => {
    switch (event.name) {
      case 'ClientPasswordEditor__PasswordDidUpdate':
      case 'SignInPage__SignedIn':
      case 'ProdStackManager__EmailConfirmed':
      case 'DemoStackManager__EmailConfirmed':
      case 'PartnerRegistrationManager__EmailConfirmed':
        return 'MANUAL';
      case 'AuthProcess__UserRecieved': {
        if (event.authType === null) {
          return 'IMPLICIT';
        }

        return prev;
      }
      case 'AuthProcess__AuthFailed':
      case 'AppErrorFallback__SignedOut':
      case 'SignOutPage__SignedOut':
      case 'ProdStackManager__SignedOut':
        return 'NONE';
      default:
        return prev;
    }
  }
);
